import { RevealSpreadsheetCellParams } from './types';

const FLASH_TIMING: KeyframeAnimationOptions = { duration: 600, iterations: 3 };

const findSheetRoot = (sheetName: string) =>
  Array.from(document.querySelectorAll<HTMLElement>('[data-sheet-name]')).find(
    element => element.dataset.sheetName === sheetName
  );

// Elements inside a hidden tab or a collapsed row group have no layout box yet.
const isLaidOut = (element?: HTMLElement | null): element is HTMLElement => Boolean(element?.getClientRects().length);

// Scrolls a spreadsheet cell into view once its tab and row group have rendered, then flashes it.
const revealSpreadsheetCell = ({ cellKey, flashColor, maxFrames = 120, sheetName }: RevealSpreadsheetCellParams) => {
  let frameId = 0;

  const tryReveal = (framesLeft: number) => {
    const sheetRoot = findSheetRoot(sheetName);
    // The title column reuses the cell id, so only match data cells.
    const cell = sheetRoot?.querySelector<HTMLElement>(`[id="CELL-${cellKey}"][data-column-legend]`);

    if (isLaidOut(cell)) {
      cell.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      cell.animate?.(
        [{ boxShadow: `inset 0 0 0 2px ${flashColor}` }, { boxShadow: 'inset 0 0 0 2px transparent' }],
        FLASH_TIMING
      );
    } else if (framesLeft > 0) {
      frameId = requestAnimationFrame(() => tryReveal(framesLeft - 1));
    } else if (isLaidOut(sheetRoot)) {
      sheetRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  frameId = requestAnimationFrame(() => tryReveal(maxFrames));

  return () => cancelAnimationFrame(frameId);
};

export default revealSpreadsheetCell;
